import { ApiRoutes } from '@gr/core/api-routes';
import type { MediaDto } from '@gr/core/content/media/dto';
import { MEDIA_FORMATS, MediaKind } from '@gr/core/content/media/formats';

export type MediaPreviewMedia = Pick<MediaDto, 'id' | 'blogId' | 'kind' | 'ext' | 'originalName' | 'hasThumbnail' | 'hasRendition'>;

export enum PreviewKind {
  Image = 'image',
  Video = 'video',
  /** Браузер файл не покажет — превью или значок формата. */
  Thumb = 'thumb',
}

export type PreviewSource = { kind: PreviewKind.Image | PreviewKind.Video; src: string } | { kind: PreviewKind.Thumb };

/**
 * POST-UC-13, POST-UC-13.CC-1: что показать крупно. Фото, которое браузер показывает сам, — оригинал,
 * HEIC и подобные — JPEG-копия; видео — оригинал, если браузер его играет.
 */
export function previewSourceOf(media: MediaPreviewMedia): PreviewSource {
  const displayable = MEDIA_FORMATS.find((f) => f.ext === media.ext.toLowerCase())?.browserDisplayable ?? false;
  const original = ApiRoutes.media.original(media.blogId, media.id);
  if (media.kind === MediaKind.Video) return displayable ? { kind: PreviewKind.Video, src: original } : { kind: PreviewKind.Thumb };
  if (displayable) return { kind: PreviewKind.Image, src: original };
  if (media.hasRendition) return { kind: PreviewKind.Image, src: ApiRoutes.media.rendition(media.blogId, media.id) };
  return { kind: PreviewKind.Thumb };
}
